module.exports = __webpack_public_path__ + "img/introduce05_left02.0ec0d394.png";